export const DAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export function normalizeDayKey(k) {
  const s = String(k || "").toLowerCase().trim();
  return DAY_KEYS.includes(s) ? s : "mon";
}

export function getTodayKey() {
  const d = new Date();
  const js = d.getDay(); // 0 Sun .. 6 Sat
  // map to our keys
  const map = {
    0: "sun",
    1: "mon",
    2: "tue",
    3: "wed",
    4: "thu",
    5: "fri",
    6: "sat",
  };
  return map[js] || "mon";
}

export function dayLabelLong(k) {
  switch (k) {
    case "mon": return "Pondělí";
    case "tue": return "Úterý";
    case "wed": return "Středa";
    case "thu": return "Čtvrtek";
    case "fri": return "Pátek";
    case "sat": return "Sobota";
    case "sun": return "Neděle";
    default: return "Den";
  }
}

export function dayLabelShort(k) {
  switch (k) {
    case "mon": return "Po";
    case "tue": return "Út";
    case "wed": return "St";
    case "thu": return "Čt";
    case "fri": return "Pá";
    case "sat": return "So";
    case "sun": return "Ne";
    default: return "";
  }
}

export function sortDaysInGroup(days) {
  const arr = Array.isArray(days) ? days.slice() : [];
  const idx = (d) => DAY_KEYS.indexOf(d);
  return arr
    .map(normalizeDayKey)
    .filter((d, i, a) => a.indexOf(d) === i)
    .sort((a, b) => idx(a) - idx(b));
}
